import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/footer";
import { IMAGES } from "../../constant/Image";
import Banner from "../../components/TitleBanner/index";
import { cardData, categoryData } from "../../constant/fake-data";
import { FaMapMarkerAlt } from "react-icons/fa";
import { BsEnvelopeFill } from "react-icons/bs";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Sellers = () => {
  const navigate = useNavigate();

  // function jo button click per chalega
  const goToSellerProfile = () => {
    navigate("/SellersProfile");
  };

  return (
    <div>
      <Header />

      <Banner
        title="Sellers"
        bgImage={IMAGES.Seller_Banner}
        breadcrumbs={["Sellers"]}
      />

      <section className="sellers-all-profiles">
        <div className="container small-container">
          <div className="row">
            <div className="col-md-4">
              <div className="seller-box">
                <div className="two-images">
                  <img
                    className="seller_profile_bg"
                    src={IMAGES.seller_profile_bg_01}
                    alt=""
                  />
                  <img
                    className="seller_profile_img"
                    src={IMAGES.seller_profile_img_01}
                    alt=""
                  />
                </div>
                <div className="content-box">
                  <h6>WilliamMotorsCA</h6>
                  <ul className="location">
                    <li>
                      <a href="/">
                        <div className="icon-box">
                          <FaMapMarkerAlt />
                        </div>{" "}
                        201 James St N, Hamilton, Ontario,Canada
                      </a>
                    </li>
                  </ul>
                  <ul className="contact-details">
                    <li>
                      <a href="mailto:example@example.com">
                        <div className="icon-box">
                          <BsEnvelopeFill />
                        </div>
                        example@example.com
                      </a>
                    </li>
                    <li>
                      <a href="tel:+123 456 78900">
                        <div className="icon-box">
                          <FaPhoneAlt />
                        </div>
                        +123 456 78900
                      </a>
                    </li>
                  </ul>
                  {/* button with navigation */}
                  <button className="view-store" onClick={goToSellerProfile}>
                    View Store
                  </button>
                </div>
              </div>
            </div>
                        <div className="col-md-4">
              <div className="seller-box">
                <div className="two-images">
                  <img
                    className="seller_profile_bg"
                    src={IMAGES.seller_profile_bg_01}
                    alt=""
                  />
                  <img
                    className="seller_profile_img"
                    src={IMAGES.seller_profile_img_01}
                    alt=""
                  />
                </div>
                <div className="content-box">
                  <h6>WilliamMotorsCA</h6>
                  <ul className="location">
                    <li>
                      <a href="/">
                        <div className="icon-box">
                          <FaMapMarkerAlt />
                        </div>{" "}
                        201 James St N, Hamilton, Ontario,Canada
                      </a>
                    </li>
                  </ul>
                  <ul className="contact-details">
                    <li>
                      <a href="mailto:example@example.com">
                        <div className="icon-box">
                          <BsEnvelopeFill />
                        </div>
                        example@example.com
                      </a>
                    </li>
                    <li>
                      <a href="tel:+123 456 78900">
                        <div className="icon-box">
                          <FaPhoneAlt />
                        </div>
                        +123 456 78900
                      </a>
                    </li>
                  </ul>
                  {/* button with navigation */}
                  <button className="view-store" onClick={goToSellerProfile}>
                    View Store
                  </button>
                </div>
              </div>
            </div>
                        <div className="col-md-4">
              <div className="seller-box">
                <div className="two-images">
                  <img
                    className="seller_profile_bg"
                    src={IMAGES.seller_profile_bg_01}
                    alt=""
                  />
                  <img
                    className="seller_profile_img"
                    src={IMAGES.seller_profile_img_01}
                    alt=""
                  />
                </div>
                <div className="content-box">
                  <h6>WilliamMotorsCA</h6>
                  <ul className="location">
                    <li>
                      <a href="/">
                        <div className="icon-box">
                          <FaMapMarkerAlt />
                        </div>{" "}
                        201 James St N, Hamilton, Ontario,Canada
                      </a>
                    </li>
                  </ul>
                  <ul className="contact-details">
                    <li>
                      <a href="mailto:example@example.com">
                        <div className="icon-box">
                          <BsEnvelopeFill />
                        </div>
                        example@example.com
                      </a>
                    </li>
                    <li>
                      <a href="tel:+123 456 78900">
                        <div className="icon-box">
                          <FaPhoneAlt />
                        </div>
                        +123 456 78900
                      </a>
                    </li>
                  </ul>
                  {/* button with navigation */}
                  <button className="view-store" onClick={goToSellerProfile}>
                    View Store
                  </button>
                </div>
              </div>
            </div>
                        <div className="col-md-4">
              <div className="seller-box">
                <div className="two-images">
                  <img
                    className="seller_profile_bg"
                    src={IMAGES.seller_profile_bg_01}
                    alt=""
                  />
                  <img
                    className="seller_profile_img"
                    src={IMAGES.seller_profile_img_01}
                    alt=""
                  />
                </div>
                <div className="content-box">
                  <h6>WilliamMotorsCA</h6>
                  <ul className="location">
                    <li>
                      <a href="/">
                        <div className="icon-box">
                          <FaMapMarkerAlt />
                        </div>{" "}
                        201 James St N, Hamilton, Ontario,Canada
                      </a>
                    </li>
                  </ul>
                  <ul className="contact-details">
                    <li>
                      <a href="mailto:example@example.com">
                        <div className="icon-box">
                          <BsEnvelopeFill />
                        </div>
                        example@example.com
                      </a>
                    </li>
                    <li>
                      <a href="tel:+123 456 78900">
                        <div className="icon-box">
                          <FaPhoneAlt />
                        </div>
                        +123 456 78900
                      </a>
                    </li>
                  </ul>
                  {/* button with navigation */}
                  <button className="view-store" onClick={goToSellerProfile}>
                    View Store
                  </button>
                </div>
              </div>
            </div>
                        <div className="col-md-4">
              <div className="seller-box">
                <div className="two-images">
                  <img
                    className="seller_profile_bg"
                    src={IMAGES.seller_profile_bg_01}
                    alt=""
                  />
                  <img
                    className="seller_profile_img"
                    src={IMAGES.seller_profile_img_01}
                    alt=""
                  />
                </div>
                <div className="content-box">
                  <h6>WilliamMotorsCA</h6>
                  <ul className="location">
                    <li>
                      <a href="/">
                        <div className="icon-box">
                          <FaMapMarkerAlt />
                        </div>{" "}
                        201 James St N, Hamilton, Ontario,Canada
                      </a>
                    </li>
                  </ul>
                  <ul className="contact-details">
                    <li>
                      <a href="mailto:example@example.com">
                        <div className="icon-box">
                          <BsEnvelopeFill />
                        </div>
                        example@example.com
                      </a>
                    </li>
                    <li>
                      <a href="tel:+123 456 78900">
                        <div className="icon-box">
                          <FaPhoneAlt />
                        </div>
                        +123 456 78900
                      </a>
                    </li>
                  </ul>
                  {/* button with navigation */}
                  <button className="view-store" onClick={goToSellerProfile}>
                    View Store
                  </button>
                </div>
              </div>
            </div>
            {/* baki seller cards ke buttons me bhi same onClick laga do */}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Sellers;
